import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#000000"
					image={require('./image.jpg')}
					title={"Ecommerce: Considerations Before Bringing Your Shop Online"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on April 21 2020  //  Posted in <strong>Web Development</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								<h2>The Current Climate:</h2>
								</div>
								
								<p><strong>This has been an extremely hard time for businesses since new restrictions and quarantine laws have been put into action in the South West. Brick and mortar stores have been sadly shutting their doors at a rapid rate as less and less foot traffic occurs. </strong></p>

								<p>You may be aware already that the current economic climate has created a fear and uncertainty around spending disposable income. And while that may be true for a lot of sectors, ecommerce and online shopping saw a 2.55% increase globally in the past week alone, while restaurants and food delivery saw a <a href="https://www.similarweb.com/coronavirus#sector-impact">5.45% rise.</a></p>

								<p><b>What does this mean?</b> A lot of families are becoming bored with home cooked meals, and are seeking new products to keep themselves happy and entertained. This could mean a new opportunity for your business. With people self isolating with not much more than their computers and mobile phones, this would be a smart time to take your business online. Maybe you’ve been thinking about it for a while but just don’t know where to start?
</p><p></p>

								<h2>Ok, so What is ecommerce?</h2>
<p> Ecommerce is the term given to websites that sell products or services online. Essentially, a customer can browse, pay and checkout all in the one site. 
If you offer physical items for sale, or services that can be sold as individual items, you should be considering moving your store online. But there are definitely factors to consider when deciding on which ecommerce platform to use. </p>
<p> <b>At Moshi Moshi, we create branded, functional, and results-driven ecommerce sites.</b> However, we have also all had experience working with most of the ‘do-it-yourself’ providers available. We’ve pooled our experiences together to create these considerations for you to take into account when creating your ecommerce site. </p>

<h2>What You Should Consider When Creating an Online Store:</h2>
<h4>Lauren (our Public Relations Manager): </h4>
<ul>
<li>A lot of the backends of the DIY providers use jargon and language that not all people will understand without some knowledge in graphic design or marketing.</li>
</ul>
<p>Keep that in mind as it may restrict the amount of data you will be able to capture and analyse, and also cost you a lot of time fiddling around. It may pay to do some research into Google Analytics codes, Facebook pixels, hex codes, and the difference between .JPG’s, .PNG’s, .SVG’s and .PDF’s for a starting point.</p>

<ul>
<li>Setting up shipping zones and currency conversions can be difficult.</li>
</ul>
<p> Make sure you have a clear plan beforehand of where you’re planning on shipping or posting to, different zones you may want to include, and whether you want to determine shipping cost by product weight or shipping zone. Product weight will require you to add weights to all of your products for sale, while shipping zones may mean someone’s getting a bargain and paying $10 flat shipping on something that cost you $60 to post. Take the time to work out your profit margin and how much of that is consumed by shipping and postage costs.  
</p>

<br></br>
<hr></hr>

<h4>David (our Marketing Director): </h4>
<ul>
<li>Google Tag Manager or Google Analytics NEED to be properly set up for effective data analysis.</li>
</ul>
<p> Either (or both) of these Analytics tools are required to gain deep insights into your customer’s behaviour. Their demographics, time spent on each page or product, and how far they proceeded through the purchase funnel are all accessible via Google Analytics. Google Tag Manager ensures that your Google tags are placed correctly through your site, and ensures all conversions, and actions are being recorded. 
</p>
<p>A lot of free platforms only offer free inhouse analytics software, offering minimal insights and data about your customer journey. Alternatively, many don’t allow Tag Manager to be properly implemented. So not only can you not see what is happening with your customers right <b>now</b>, but you can’t predict future behaviour either. Without Google Analytics and/or Tag Manager you can't properly plug into Google's machine learning platform, which learns about the people who convert the best on your website to assist your Google Ads management.</p>

<ul>
<li>Google Shopping ads are pulled directly from your site content, so make sure products are set up correctly. </li>
</ul>
<p> This is hard to do and manage at the best of times, and simply not available with some free platforms. When done right (by professionals) it not only opens your business up to Google Shopping searches but also to machine learning remarketing assets that are not available for normal search campaigns.
Proper Google Shopping setup = massive marketing potential for your business.</p>

<br></br>
<hr></hr>

<h4>Karl (our Creative Director): </h4>
<ul>
<li>Weigh up if the low price of this provider is worth the time it takes to get the site looking good and functioning properly.</li>
</ul>
<p> Generally, what you save in costs you double up on with your time. As a general rule, it’s better to get it done right the first time and pay the little extra for a professional to make your site.</p>

<ul>
<li>Start with 10 products, and see how the user path functions. </li>
</ul>
<p> I suggest you upload 10 products to start with, and analyse how your site performs. Is it receiving traffic? Is there demand for your products? Are they presented as best they can be? And most importantly, are people finding it easy to follow the product to checkout path? It may be that once items are in their basket, your users are exiting the page because the checkout process is too difficult. On a properly created ecommerce site, your analytics should be able to tell you where people are dropping off, and which pages they spend the most time on, so you can edit and change accordingly. 
</p>


<br></br>
<hr></hr>

<h4>Adrian (our Technical Director): </h4>
<ul>
<li>Think about your SEO and Page Rank.</li>
</ul>
<p>Third party ecommerce platforms offer quite similar templates - there’s nothing to really set them apart from each other, which affects SEO. The more unique a page, the better Google ranks it. </p>
<p>Hosting is another factor that lends itself to SEO - often free ecommerce providers are hosting outside of Australia, leading to longer load times of images and content. Another SEO consideration is that older technology used on these builder sites (such as Flash) isn’t able to be crawled or indexed as easily, making your page rank a lot lower than if you were to use a modern web designer. </p>

<ul>
<li>Templated sites mean the user experience is locked in already. </li>
</ul>
<p>A lot of the time, the main 4 ecommerce platform providers have created templates for you that are designed from a well-working machine - all you have to do is fill in the blanks. While this already means your site isn’t very unique, it also means your user experience has to follow the path they’ve laid out for you. This may work out well for you, it may work out badly. The issue is, there’s no way of knowing until you’ve already paid for your template, and it’s hard to change if it turns out to be working badly for you.</p>

<br></br>
<hr></hr>

<h4>Daz (our Project Manager): </h4>
<ul>
<li>Maximise your branding by building your site with professionals.</li>
</ul>
<p>Third party ecommerce platforms are great if you’re after something cheap. But if you want to fully utilise your branding and create a visually impactful site, a professional website builder is the way to go. While third party platforms can offer font changes and logo uploads, we create an entire site based on the look and message behind your brand as a whole, giving your user a full experience rather than just a pretty visual.</p>

<ul>
<li>Be wary of hidden costs.</li>
</ul>
<p>Often, what can seem a better deal at the start can include a whole array of hidden costs. Costs to add credit card functionality, costs to add more than five products, costs for the site template and THEN costs to renew every year. Make sure you take a good look around the platform during your trial period and take note of what incurs additional fees. </p>

<br></br>
<hr></hr>

<h2>In Conclusion...</h2>
<p>A professional, expert web design may cost a little extra, but the flexibility in branding and user paths, the correct installation of Google marketing tools, and the amount of time you save overall is worth it (in our opinion!). </p>
<p>So read up on all of the platforms available, look into your processes and funnels, and take care of yourselves and your businesses. </p>
								

								<img src={require('./image-2.png')} alt="Hearth House Website Example" className="align-centre" align="centre" />
<img src={require('./image-3.png')} alt="LPC Website Example" className="align-centre" align="centre" />
<img src={require('./image-4.png')} alt="Picton Trailer Hire Website Example" className="align-centre" align="centre" />
								
								



							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/Ecommerce/index.js